import { useCallback } from 'react';
import type { TabId } from '../../components/mui/common/Tabs';
import { useFormRegistry } from '../../contexts/FormRegistryProvider';
import type { BlockingType } from '../../contexts/ActionBlockerProvider';
import { useActionBlocker } from '../../contexts/ActionBlockerProvider';

interface UseTabSelectionOptions {
  formNamespace: string;
  onSuccess?: (tab: TabId) => void;
}

interface UseTabSelectionReturn {
  handleSelectTab: (type: BlockingType, tab: TabId) => Promise<void>;
  handleOnSelectTab: (tab: TabId) => void;
}

export function useTabSelection({ formNamespace, onSuccess }: UseTabSelectionOptions): UseTabSelectionReturn {
  const { triggerForms, createAllFormSnapshot } = useFormRegistry(formNamespace);
  const { executeDelayed } = useActionBlocker();

  const handleOnSelectTab = useCallback(
    (tab: TabId) => {
      createAllFormSnapshot();
      onSuccess?.(tab);
    },
    [createAllFormSnapshot, onSuccess]
  );

  const handleSelectTab = useCallback(
    async (type: BlockingType, tab: TabId) => {
      await triggerForms();

      executeDelayed(type, () => handleOnSelectTab(tab));
    },
    [triggerForms, executeDelayed, handleOnSelectTab]
  );

  return { handleSelectTab, handleOnSelectTab };
}
